import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import theme, { combineValues } from '@cld/theme-helper';
import BaseButton from './BaseButton';
import { propTypes, TYPE } from './props';

const t = theme({ basePath: 'components.button' });

const hoverCss = css`
  :hover {
    background-color: ${combineValues(t`${'shape'}.${'type'}.background.color`, (color) => rgba(color, 0.06))};
  }
`;

const activeCss = css`
  :active {
    background-color: ${combineValues(t`${'shape'}.${'type'}.background.color`, (color) => rgba(color, 0.12))};
  }
`;

const StyledMenuButton = styled(BaseButton)`
  ${(props) =>
    !props.selected &&
    css`
      ${hoverCss} ${activeCss}
    `}
`;

StyledMenuButton.propTypes = propTypes;
StyledMenuButton.defaultProps = {
  type: TYPE.MENU,
};

export default StyledMenuButton;
